import BaseService from './BaseService'
import config from './../config/index'
import { requests } from '.'

class LCPhoneService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  listRegulatoryBundles = async (locationId: string) => {
    const { data } = await this.requests.get(`/regulatory-bundles/list?locationId=${locationId}`)
    return data
  }
  submitAddressInformation = async (data: any) => {
    const response = await this.requests.post('/regulatory-bundles/address', data)
    return response
  }
  createRegulatoryBundle = async (data: any) => {
    const response = await this.requests.post('/regulatory-bundles', data)
    return response
  }
  createEndUser = async (data: any) => {
    const response = await this.requests.post('/regulatory-bundles/end-user', data)
    return response
  }
  listAddresses = async (locationId: string) => {
    const response = await this.requests.get(`/regulatory-bundles/addresses?locationId=${locationId}`)
    return response
  }
  submitRegulatoryBundle = async (data: any) => {
    const response = await this.requests.post('/regulatory-bundles/submit', data)
    return response
  }
  attachDocuments = async (data: any) => {
    const response = await this.requests.post('/regulatory-bundles/attach-documents', data)
    return response
  }
  deleteBundle = async (data: any) => {
    const response = await this.requests.delete(`/regulatory-bundles?locationId=${data.locationId}&bundleSid=${data.bundleSid}`)
    return response
  }
  deleteAddress = async (data: any) => {
    const response = await this.requests.delete(`/regulatory-bundles/address?locationId=${data.locationId}&addressSid=${data.addressSid}`)
    return response
  }
  getBundleDetails = async (data: any) => {
    const response = await this.requests.get(`/regulatory-bundles/bundle-details?locationId=${data.locationId}&bundleSid=${data.bundleSid}`)
    return response
  }
  getRejectionReason = async (data: any) => {
    const response = await this.requests.get(`/regulatory-bundles/rejection-reason?locationId=${data.locationId}&bundleSID=${data.bundleSid}`)
    return response
  }
  putTwilioData = async (locationId: string, data: any) => {
    const response = await this.requests.put(`/twilio-accounts?locationId=${locationId}`, data)
    return response
  }
}

export const LcPhoneService = new LCPhoneService(config.ghlRevexBackendUrl)

export default {}
